import React, { useCallback, useEffect } from 'react';
import {LabInformationBackendService} from './services/LabInformationBackendService';
import * as actionType from './store/actionTypes';
import {Wrapper} from './feature/wrapper';
import { useDispatch } from 'react-redux';

function App (){
  const dispatch = useDispatch();
  const loadLabels = useCallback((data) => dispatch({ type: actionType.LOAD_LABELS, payload: data }), [dispatch]);
  const setDefaultStyle = useCallback((data) => dispatch({ type: actionType.LOAD_DEFAULT_STYLE, payload: data }), [dispatch]);
  const setDefaultLanguage= useCallback((data) => dispatch({ type: actionType.CHANGE_DEFAULT_LANGUAGES, payload: data }), [dispatch]);
  // const loadLanguages= useCallback((data) => dispatch({type: actionType.LOAD_LANGUAGES, payload: data}), [dispatch]);
  // const cacheLanguage = localStorage.getItem("defaultLanguage");
  useEffect(() => { 
    LabInformationBackendService.loadConfigFile().then((res)=> {
      return LabInformationBackendService.loadLabelsFile(res.LabelInfo);
    }).then(res=>{
        console.log(JSON.stringify(res));
        setDefaultStyle(res.defaultStyle);
        setDefaultLanguage(res.defaultLanguage);
        loadLabels(res.localization[0].labels)
    });
  });
  return (
    <div className="App">
      <Wrapper />
    </div>
  );
}


export default App;